// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors-node_modules_babel_polyfill_lib_index_js-node_modules_splidejs_vue-splide_src_js_inde-579e1b"], () => (__webpack_require__("../node_modules/@babel/polyfill/lib/index.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_babel_polyfill_lib_index_js-node_modules_splidejs_vue-splide_src_js_inde-579e1b"], () => (__webpack_require__("./index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
